import { boot } from 'quasar/wrappers'
import { longClickDirective } from 'vue-long-click'

export default boot(({ app }) => {
  const longClickInstance = longClickDirective({delay: 400, interval: 50})
  app.directive('longclick', longClickInstance)
})
